<template>
  <div class="card" v-if="validaTipoAtendimento()">
    <div class="card-body">
      <div class="row">
        <video id="video" width="600" height="400" style="margin-left:1%" v-show="screenQrCode"></video>
      </div>
      <div class="row">
        <div class="col-12 col-lg-2 text-left striped-sm">
          <div class="d-inline d-lg-block mr-2">{{ $t('Problema') }}:</div>
          <strong>{{ os.ds_conjunto }}</strong>
        </div>
        <div class="col-12 col-lg-8 text-left ">
          <div class="d-inline d-lg-block mr-2">{{ $t('Serviços') }}:</div>
          <strong>{{ descricaoItem }}</strong>
        </div>

        <!-- Botões -->
        <!-- <div v-if="!exibeBotoes" class="col alert alert-success text-center" role="alert"
          style="margin-bottom: 0px; margin-right: 3px;">
          Serviço atendido com sucesso!
        </div> -->
        <div class="col-12 col-lg-2 col-xl-2 text-left  mt-md-4 mt-lg-0">
          <div class="row">
            <div class="col-12 d-md-block d-lg-none mb-2">{{ $t('Ações') }}</div>
            <div class="col-xs-12 col-md-4 col-lg-12" v-if="isEncerrada">
              <span class="badge badge-secondary p-2 w-100 mb-2">
                <i class="fas fa-lock mr-1"></i> {{ $t('Somente Consulta') }}
              </span>
            </div>
            <div class="col-xs-12 col-md-4 col-lg-12" v-if="!isEncerrada && showEncerrarButton && showExecucaoButton">
              <button @click="validaFinalizar('parar')" id="btnParar" class="btn btn-danger btn-block mb-2"
                v-show="pause && agAtendimento">
                <i class="fas fa-stop"></i> {{ descBtnCancelar }}
              </button>
            </div>
            <div class="col-xs-12 col-md-4 col-lg-12" v-if="!isEncerrada">
              <button class="btn btn-success btn-block mb-2" :disabled="disabledPeca || disabledContinuar"
                v-show="!pause" @click="continuar()">
                <i class="fas fa-play"></i> {{ $t('Continuar') }}
              </button> 
            </div>
            <div v-if="disabledContinuar" class="col alert alert-warning text-center" role="alert"
              style="margin-bottom: 0px; margin-right: 3px;">
              Existe uma ordem de compra em aberto
            </div>
            <div class="col-xs-12 col-md-4 col-lg-12"
              v-if="!isEncerrada && showEncerrarButton && showExecucaoButton && !verificaOsExterna">
              <b-button v-b-modal.modal-pause class="btn btn-warning btn-block mb-2" v-show="pause && agAtendimento"
                :disabled="disabled || osOutroMecanico">
                <i class="fas fa-pause && agAtendimento"></i> {{ $t('Pausar') }}
              </b-button>
            </div>
            <div class="col-xs-12 col-md-4 col-lg-12"
              v-if="!isEncerrada && showEncerrarButton && showExecucaoButton  && verificaOsAbastecimento">
              <button @click="showModalItemsFim = true, exibeFinalizar = false" id="btnParar"
                class="btn btn-success btn-block mb-2" v-show="pause && agAtendimento">
                <i class="fa fa-cog" aria-hidden="true"></i> {{ $t('Registrar Peças') }}
              </button>
            </div>
            <div class="col-xs-12  col-md-4 col-lg-12"
              v-if="!isEncerrada && showEncerrarButton && showExecucaoButton && fornecExt && !verificaOsExterna && !verificaPreventiva">
              <b-button class="btn btn-danger btn-block mb-2" v-show="pause && agAtendimento" @click="$refs.showModalcancelarOs.show()"
                :disabled="disabled || osOutroMecanico">
                <i class="fa fa-ban"></i> {{ $t('Cancelar OS') }}
              </b-button>
            </div>
            <div class="col-xs-12 col-md-4 col-lg-12"
              v-if="!isEncerrada && showIniciarButton && showExecucaoButton && pause && agAtendimento">
              <button class="btn btn-success btn-block mb-2" :disabled="disabledPeca" @click="validaIniciar('iniciar')">
                <i class="fas fa-play"></i> {{ $t('Iniciar') }}
              </button>
            </div>
            <div class="col-xs-12  col-md-4 col-lg-12"
              v-if="!isEncerrada && fornecExt && !verificaOsExterna && !verificaPreventiva && userLogadoMecanico">
              <button class="btn btn-primary btn-block mb-2" v-show="pause && agAtendimento"
                @click="modalExterna = true" :disabled="disabled">
                <i class="fa fa-file-export"></i> {{ $t('OS Externa') }}
              </button>
            </div>
            <div class="col-xs-12  col-md-4 col-lg-12"
              v-if="!isEncerrada && fornecExt && !verificaOsExterna && !verificaPreventiva && userLogadoMecanico">
              <button class="btn btn-secondary btn-block mb-2" v-show="pause && agAtendimento"
                @click="modalOrcamento = true" :disabled="disabled">
                <i class="fa fa-file-pdf"></i> {{ $t('Orçamento') }}
              </button>
            </div>
            <div v-show="!isEncerrada && verificaArmazem">
              <div class="col-xs-12  col-md-4 col-lg-12" v-if="!btnAguardandoLiberacao">
                <button class="btn btn-warning btn-block mb-2" @click="aguardandoLiberacao" :disabled="disabled">
                  <i class="fa fa-check-square"></i> {{ $t('Aguardar Liberação') }}
                </button>
              </div>
              <div class="col-xs-12  col-md-4 col-lg-12" v-if="btnAguardandoLiberacao">
                <button class="btn btn-success btn-block mb-2" @click="finalizarLiberacao" :disabled="disabled">
                  <i class="fa fa-check-square"></i> {{ $t('Equipamento Liberado') }}
                </button>
              </div>
            </div>
            <div class="col-xs-12  col-md-4 col-lg-12"
              v-if="!isEncerrada && showEncerrarButton && showExecucaoButton && fornecExt && !verificaOsExterna && !verificaPreventiva && verificaBtnSinistro">
              <button class="btn btn-info btn-block mb-2" v-show="pause && agAtendimento"
                @click="showModalSinistro = true" :disabled="disabled || osOutroMecanico">
                <i class="fa fa-bell"></i> {{ $t('Informar Sinistro') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modais -->
    <modal-items @saveItem="finalizarOs" :os="os" @showModalItems="showModalItems = false"
      v-if="showModalItems"></modal-items>
    <modal-servicos :os="os" @showModaServicos="showModaServicos = false" v-if="showModaServicos"></modal-servicos>
    <modal-fornecedores @saveFornec="fornecOs" :os="os" @showModalFornec="showModalFornec = false"
      v-if="showModalFornec"></modal-fornecedores>
    <modal-items-fim @showModalItemsFim="showModalItemsFim = false, exibeFinalizar = true" @finalizaOS="parar"
      :valuesOsTransfered=this.valuesTrasferMethodParar :exibeFinalizar="exibeFinalizar" :tipo_os="'proativa'"
      :nr_sequencial_servico="nr_sequencial_servico" :item="item" :os="os" v-if="showModalItemsFim"></modal-items-fim>
    <modal-externa @fechaModal="modalExterna = false" @enviaOsExterna="enviaOsExterna" :item="item"
      v-if="modalExterna"></modal-externa>
    
    <modal-orcamento @fechaModal="modalOrcamento = false" @iniciarOrcamento="iniciarOrcamento" :item="item"
      v-if="modalOrcamento"></modal-orcamento>

    <modal-sinistro @saveItem="finalizarOs" :os="os" @fechaModal="showModalSinistro = false"
      v-if="showModalSinistro"></modal-sinistro>

    <modal-pause :item="item" :os="os" @resetPause="resetPause"></modal-pause>

    
    <b-modal 
      ref="showModalcancelarOs" 
      hide-footer 
      :title="$t('Informe a Justificativa')"
    >
      <b-form novalidate @submit.prevent="onConfirmCancelar">
        <!-- Select da justificativa -->
        <b-form-group :label="$t('Justificativa')" label-for="selectCancelar">
          <b-form-select 
            id="selectCancelar" 
            v-model="form.justificativa"
            :options="[
              { value: null, text: $t('Selecione uma justificativa') },
              { value: 'Erro do Motorista', text: $t('Erro do Motorista') },
              { value: 'Defeito não Encontrado', text: $t('Defeito não Encontrado') }
            ]"
            required
          />
        </b-form-group>

        <!-- Campo de observação -->
        <b-form-group :label="$t('Observação')" label-for="obs">
          <b-form-input
            id="obs"
            v-model="form.obs"
            :placeholder="$t('Observação')"
          />
        </b-form-group>
    
        <!-- Upload de arquivos -->
        <b-form-group :label="$t('Anexos')">
          <UploadArquivos />
        </b-form-group>

        <!-- Botões -->
        <div class="d-flex justify-content-center">
          <b-button variant="danger" @click="$refs.showModalcancelarOs.hide()">
            {{ $t('Cancelar') }}
          </b-button>
          <b-button type="submit" variant="primary" class="ml-2">
            {{ $t('Confirmar Cancelamento') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import ModalItems from './Modais/ModalItems'
import ModalServicos from './Modais/ModalServicos'
import ModalExterna from './Modais/ModalExterna'
import ModalOrcamento from './Modais/ModalOrcamento'
import ModalSinistro from './Modais/ModalSinistro'
import ModalFornecedores from './Modais/ModalFornecedores.vue';
import ModalItemsFim from './Modais/ModalItemsFim.vue'
import UploadArquivos from './Modais/UploadArquivos.vue';
import ModalPause from './Modais/ModalPause.vue';
// import enviarMensagem from './api-whatsapp/index';


export default {
  props: {
    item: {},
    os: {},
    disabled: { type: Boolean, default: false },
    initAt: {}
  },
  data() {
    return {
      pause: true,
      agAtendimento: true,
      exibeFinalizar: true,
      justificativa: '',
      cod_item: '',
      validaOsExterna: false,
      showModalItems: false,
      showModalFornec: false,
      disabledPeca: false,
      quantidade: 0,
      showModalItemsFim: false,
      disabledIniciar: false,
      screenQrCode: false,
      nr_sequencial_servico: '',
      obsExternaPecas: '',
      valuesTrasferMethodParar: '',
      validateIniciar: false,
      modalExterna: false,
      modalOrcamento: false,
      showModalSinistro: false,
      showModaServicos: false,
      validaOsAbastecimento: false,
      disabledContinuar: false,
      form: {
        justificativa: null,
        obs: ''
      },
      statusOrcamento: false
    }
  },
  components: {
    ModalItems,
    ModalServicos,
    ModalFornecedores,
    ModalItemsFim,
    UploadArquivos,
    ModalExterna,
    ModalOrcamento,
    ModalSinistro,
    ModalPause 
  },
  computed: {
    isEncerrada() {
      return this.os && this.os.st_os && this.os.st_os !== 'A' && this.os.st_os !== 'R'
    },
    verificaOsAbastecimento(){
      this.validaOsAbastecimento = false

      if(this.os.tp_os_conjunto == "C"){
        this.validaOsAbastecimento = true
        return false
      }
      return true
    },  
    exibeBotoes(){
      console.log(this.item)
      if(this.item.item_atendido && this.os.st_origem == 'E') {
        return false
      } 

      return true
    },
    verificaArmazem(){
      if(this.os.departamento_os == 'ARMAZEM'){
        return true
      } else {
        return false
      }
    },
 
    btnAguardandoLiberacao() {
      if(this.os.st_os == 'L') {
        return true
      }

      return false 
    },
    verificaBtnSinistro() {
      if (this.os.st_contrato_vamos && this.os.departamento_os == 'ARMAZEM') {
        return true
      }

      return false
    },

    continueOrStart() {
      if (this.os.st_os == "P") {
        return true
      }

      return
    },
    itemAtendido() {
      if (this.os.nr_seq_tipo == 'V' || this.os.nr_seq_tipo == 'R' || this.os.tp_os == 'V' || this.os.tp_os == 'R') {
        return this.item.item_atendido
      }

      return false
    },
    osOutroMecanico() {
      const filial = this.$store.getters['filial/filial']
      if (this.item.execucao_inicio.nr_seq_clifor_inicio == filial.tecnicoId || filial.atendeOs != "S" || filial.fornecExt == 'S') {
        return false
      }

      return true
    },

    userLogadoMecanico() {
      const filial = this.$store.getters['filial/filial']

      if (filial.atendeOs !== "S") {
        return true
      }

      if(filial.atendeOs == "S" && this.item.execucao_inicio){
        return true
      }

      return false
    },

    descBtnCancelar() {
      if (this.os.nr_seq_tipo == 'V' || this.os.nr_seq_tipo == 'R' || this.os.tp_os == 'V' || this.os.tp_os == 'R') {
        return 'Encerrar Serviço'
      } else {
        return this.$t('Encerrar OS')
      }
    },

    verificaOsExterna() {
      const filial = JSON.parse(localStorage.filial);
      if (this.os.st_origem == "E") {
        return true
      }

      return false
    },

    verificaPreventiva() {
      if (this.os.nr_seq_tipo == 'V' || this.os.nr_seq_tipo == 'R' || this.os.tp_os == 'V' || this.os.tp_os == 'R') {
        return true
      } else {
        return false
      }
    },

    fornecExt() {
      const filial = JSON.parse(localStorage.filial);

      if (filial.fornecExt === 'S') {
        return false
      }

      return true
    },

    showButtonFornec() {
      const filial = JSON.parse(localStorage.filial);

      if (filial.fornecExt == null && this.os.st_origem == "E") {
        return true
      }

      return false
    },

    showIniciarButton() {
      if (!this.showExecucaoButton) {
        return false
      }

      if (!this.item.execucao_inicio) {
        return true
      }

      if (this.item.execucao_final && this.item.execucao_final.dt_final && this.item.execucao_final.nr_seq_clifor_final) {
        return true
      }
      // this.validaPause(this.item.nr_sequencial)
      return false
    },

    showEncerrarButton() {
      if(this.os.st_os == 'L'){
        return false
      }

      return !this.showIniciarButton
    },

    isExecutavel() {
      return (
        this.item &&
        this.item.item &&
        this.item.item.tipo &&
        this.item.item.tipo.st_habilita_execucao
      )
    },

    showExecucaoButton() {
      return this.isExecutavel
    },

    descricaoTipo() {
      if (this.item && this.item.item && this.item.item.tipo) {
        return this.item.item.tipo.ds_tipoitem
      }

      return ''
    },

    descricaoItem() {
      var descricao = ''

      if (this.descricaoTipo.length) {
        descricao = this.$t(this.descricaoTipo) + ' | '
      }
      console.log(this.descricaoTipo)

      if (this.item.item) {
        descricao += this.item.item.ds_item
      }

      if (!this.isExecutavel && this.item.estoque) {
        descricao += ` — ${this.item.estoque.ds_codigoitem}`
      }

      return descricao
    },

  },

  created() {
    console.log(this.item)

    if (this.initAt) {
      if (this.showIniciarButton) {
        if (this.os.ds_tipo == "CORRETIVA" || this.os.ds_tipo == "PROATIVA") {
          this.iniciar()
        }
      }
    }
    const filial = this.$store.getters['filial/filial']
    if (this.os.st_origem === 'E' && this.os.nr_seq_fornecedor == 23 && filial.fornecExt == null) {
      this.showModalFornec = true
    }

    if (this.os.st_os_pause == "P") {
      this.pause = false
    }

    if (this.os.st_os == "L") {
      this.agAtendimento = false
    }

    if (this.os.st_os == 'E') {
      this.disabledPeca = true
    }

  },

  mounted() {
    if (this.$route.params.osExterna == 'osExterna') {
      document.getElementById('btnParar').click()
    }

    this.verificaBloqueioOC()
  },

  methods: {
    aguardandoLiberacao() {
      this.$root.confirmIdentity({
        onConfirmIdentity: (tecnicoId) => {
          
          const data = {
            tecnico: tecnicoId,
            os: this.$route.params.id
          }
          
          this.$store.dispatch('osItemExecucao/enviaAguardandoLiberacao', { data: data }).then(response => {
            if(response.data){
              this.$store.dispatch('osItem/fetchItemFromApi', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
              this.$store.dispatch('osItemExecucao/fetchIniciadasFromApi')  
              window.location.reload()
            }
          })
        }
      })
    },

    finalizarLiberacao() {
      this.$root.confirmIdentity({
        onConfirmIdentity: (tecnicoId) => {
          
          const data = {
            tecnico: tecnicoId,
            os: this.$route.params.id
          }
          
          this.$store.dispatch('osItemExecucao/finalizarLiberacao', { data: data }).then(response => {
            if(response.data){
              this.$store.dispatch('osItem/fetchItemFromApi', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
              this.$store.dispatch('osItemExecucao/fetchIniciadasFromApi')  
              window.location.reload()
            }
          })
        }
      })
    },

    validaTipoAtendimento() {
      try {
        if (this.item.item.tipo.nr_sequencial == 3) {
          return true
        } else {
          return false
        }

      } catch (error) {
        return false
      }
    },

    fornecOs(codOs, codFornec) {
      const data = {
        nr_os: codOs,
        nr_fornec: codFornec
      }

      this.$store.dispatch('os/enviaOsExterna', { data: data }).then(response => {
        this.showModalFornec = false

        this.$swal.fire({
          title: "Sucesso",
          text: "Ordem de serviço, vinculada com Sucesso!",
          icon: "success"
        })

        window.location.reload()
      }).catch(error => {
        console.log(error)
      })
    },

    exibeSelectPecas(){
      console.log('Entrouuu')
    },

    // cancelarOs() {
    //   this.$swal
    //     .fire({
    //       title: this.$t('Informe a Justificativa'),
    //       html: `<select class="custom-select custom-select-lg mb-3" id="selectCancelar">
    //         <option selected>Justificativa</option><option value="Erro do Motorista">${this.$t('Erro do Motorista')}</option>
    //         <option value="Defeito não Encontrado">${this.$t('Defeito não Encontrado')}</option>
    //         </select>`,
    //       showCancelButton: true,
    //       input: 'text',
    //       inputAttributes: {
    //         placeholder: 'Observação'
    //       },
    //       cancelButtonColor: '#d33',
    //       cancelButtonText: 'Cancelar',
    //       confirmButtonText: 'Confirmar Cancelamento'
    //     })
    //     .then(result => {
    //       if (result.dismiss !== 'cancel' && result.dismiss !== 'backdrop') {
    //         if (document.getElementById('selectCancelar').value === 'Justificativa') {
    //           this.$swal.fire('Oops!', this.$t('Informe a Justificativa'), 'error')
    //         } else {
    //           const filial = this.$store.getters['filial/filial']
    onConfirmCancelar() {
      if (!this.form.justificativa) {
        this.$swal.fire(this.$t('Oops!'), this.$t('Informe a Justificativa'), 'error')
        return
      }

      const filial = this.$store.getters['filial/filial']
      const execucao = {
        nr_os: this.$route.params.id,
        justificativa_cancelamento: this.form.justificativa,
        idTecnico: filial.tecnicoId,
        obs: this.form.obs,
        id: this.item.execucao_final.id,
        nr_seq_os_item: this.item.nr_sequencial,
      }

      this.$store.dispatch('osItemExecucao/cancelarOs', { data: execucao })
        .then(response => {
          if (document.getElementById('formFiles').value != '') {
            const files = this.$store.state.os.filesUpload
            const formData = new FormData();

            for (let i = 0; i < files.length; i++) {
                formData.append('files[]', files[i]);
            }

            this.$store.dispatch(`os/uploadFiles`, { data: formData, nrSeqOs: this.$route.params.id }).then(() => {
              window.location.href = '/'
            })
          } else {
            window.location.href = '/'
          }
        })
        .catch(() => {
          this.$swal.fire({
            title: this.$t('Oops!'),
            text: this.$t('Falha ao cancelar execução. Tente novamente.'),
            icon: 'error'
          })
        })
    },
    //           const execucao = {
    //             nr_os: this.$route.params.id,
    //             justificativa_cancelamento: document.getElementById('selectCancelar').value,
    //             idTecnico: filial.tecnicoId,
    //             obs: result.value,
    //             id: this.item.execucao_final.id,
    //             nr_seq_os_item: this.item.nr_sequencial,
    //           }
    //           this.$store.dispatch('osItemExecucao/cancelarOs', { data: execucao }).then(response => {
    //             window.location.href = '/'
    //           }).catch(() => { 
    //             this.$swal.fire({
    //               title: 'Oops!',
    //               text: 'Falha ao cancelar execução. Tente novamente.',
    //               icon: 'error'
    //             })

    //             return false
    //           })
    //         }
    //       }
    //     })
    //     .catch(erro => {
    //       console.log('error', erro)
    //       this.$swal.fire('Oops!', 'Falha ao cancelar', 'error')
    //     })
    // },

    finalizarOs(valuesOS) {
      this.nr_sequencial_servico = valuesOS.nr_servico
      if (!valuesOS.nr_servico) {
        this.$swal.fire({
          title: 'Oops!',
          text: this.$t('Insira um serviço. Tente novamente.'),
          icon: 'error'
        })

      } else {
 
        const filial = this.$store.getters['filial/filial']

        if (filial.fornecExt === "S" || this.validaOsAbastecimento == true) {
          this.parar(valuesOS)
          this.show = false
        } else {
          this.$swal.fire({
            title: this.$t('Foi utilizado Peças?'),
            text: this.$t('Se foi utilizado peças neste atendimento, pressione "Sim" na opção abaixo!'),
            icon: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#d33',
            cancelButtonText: this.$t('Não'),
            confirmButtonText: this.$t('Sim')
          })
            .then(result => {
              if (result.value) {
                // this.obsExternaPecas = valuesOS.obsExterna
                this.valuesTrasferMethodParar = valuesOS
                this.showModalItemsFim = true
              } else {
                this.parar(valuesOS)
                this.show = false
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      }
    },

    osExterna() {

      return false
      this.$swal.fire({
        title: this.$t('Confirmar OS Externa'),
        input: 'text',
        inputAttributes: {
          placeholder: this.$t('Observação')
        },
        text: `${this.$t('Deseja realmente enviar OS')} N°${this.$route.params.id}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirmar')
      }).then(result => {
        if (result.dismiss !== 'cancel' && result.dismiss !== 'backdrop') {



          this.$store.dispatch('os/getDetails', { nrSequencial: this.$route.params.id }).then(response => {
            const execucao = {
              nr_os: Number(this.$route.params.id),
              obs: result.value,
              adm: false
            }
            const filial = this.$store.getters['filial/filial']

            if (filial.atendeOs != "S") {
              execucao.adm = true
            }

            if (response.data.execucao_inicio) {
              this.cod_item = this.item.nr_seq_item

              const execucaoParar = {
                id: this.item.execucao_final.id,
                nr_seq_os_item_update: this.cod_item,
                nr_seq_os_item: this.item.nr_sequencial,
                nr_seq_os: this.$route.params.id,
                nr_seq_clifor: response.data.execucao_inicio.nr_seq_clifor_inicio,
                nr_os: this.$route.params.id,
                validaExt: false,
                obsExterna: result.value,
                osExterna: false,
              }

              this.enviaOsExterna(execucao)

              this.$store.dispatch('osItemExecucao/update', { data: execucaoParar }).then(response => {
                this.$store.dispatch('osItem/fetchItemFromApi', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
                this.$store.dispatch('osItem/fetchItemFromApiPreventiva', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
              })
              // this.parar('', execucao)
              console.log('Executa o parar')
            } else {
              this.enviaOsExterna(execucao)
            }

          })


        }
      }).catch((error) => {
        console.log(error)
      })
    },

    enviaOsExterna(execucao) {
      this.$store.dispatch('os/osExterna', { data: execucao, }).then(response => {
        window.location.href = '/'
      }).catch((error) => {
          this.$swal.fire({
            title: 'Oops!',
            text: 'Já existe uma OS externa idêntica aberta no sistema!',
            icon: 'error'
          })
      })
    },

    validaFinalizar(tipoAcao) {
      if (this.isEncerrada) {
        this.$swal.fire({
          title: this.$t('Atenção!'),
          text: this.$t('Esta Ordem de Serviço já foi encerrada no GINFO. O atendimento não pode mais ser alterado.'),
          icon: 'warning'
        })
        return
      }
      this.showModalItems = true
    },

    validaModal() {
      if (this.isEncerrada) {
        this.$swal.fire({
          title: 'Atenção!',
          text: this.$t('Esta Ordem de Serviço já foi encerrada no GINFO. O atendimento não pode mais ser alterado.'),
          icon: 'warning'
        })
        return
      }
      if (this.os.ds_tipo == "CORRETIVA" || this.os.ds_tipo == "PROATIVA") {
        this.showModalItems = true
      } else {
        this.parar()
      }
    },

    iniciaPause() {
      this.pause = true
    },

    validaIniciar(tipoAcao) {
      if (this.isEncerrada) {
        this.$swal.fire({
          title: 'Atenção!',
          text: this.$t('Esta Ordem de Serviço já foi encerrada no GINFO. O atendimento não pode mais ser alterado.'),
          icon: 'warning'
        })
        return
      }
      const filial = this.$store.getters['filial/filial']
      if (this.os.st_origem == 'E' && this.os.nr_seq_fornecedor === 23) {
        this.showModalFornec = true
      } else {
        this.iniciar()
      }
    },

    iniciarOrcamento() {
      this.modalOrcamento = false
      this.statusOrcamento = true

      const fornecExt = this.$store.getters['filial/filial']

      const execucao = {
        nr_seq_os_item: this.item.nr_sequencial,
        nr_seq_clifor: null,
        validaExt: null,
        nr_seq_tipo: this.os.nr_seq_tipo,
        osExterna: false,
        nr_os: this.$route.params.id
      }

      this.$store.dispatch('osItemExecucao/create', { data: execucao }).then(response => {
        this.$store.dispatch('osItem/fetchItemFromApi', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })

        setTimeout(() => {
          const execucao2 = {
            nr_seq_os: this.$route.params.id,
            id: this.item.execucao_final ? this.item.execucao_final.id : null,
            nr_seq_os_item: this.item.nr_sequencial,
            nr_seq_clifor: this.item.execucao_inicio ? this.item.execucao_inicio.nr_seq_clifor_inicio : null,
            justificativa: 'aguardando_orcamento'
          }

          this.$store.dispatch('osItemExecucao/initPause', { data: execucao2 }).then(response => {
            this.$store.dispatch('osItem/fetchItemFromApi', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
            this.$store.dispatch('osItemExecucao/fetchIniciadasFromApi')
            this.pause = false
            this.disabledPeca = false
          }).catch(() => {
            this.$swal.fire({
              title: 'Oops!',
              text: 'Falha ao pausar execução. Tente novamente.',
              icon: 'error'
            })

            return false
          })
        }, 2000)

      }).catch(() => {
        this.$swal.fire({
          title: 'Oops!',
          text: 'Falha ao iniciar execução. Tente novamente.',
          icon: 'error'
        })
        return false
      })
    }, 

    iniciar() {
      if (this.isEncerrada) {
        this.$swal.fire({
          title: 'Atenção!',
          text: this.$t('Esta Ordem de Serviço já foi encerrada no GINFO. O atendimento não pode mais ser alterado.'),
          icon: 'warning'
        })
        return
      }
      this.iniciaPause() 
      this.disabledPeca = true
      const fornecExt = this.$store.getters['filial/filial']

      if (this.os.st_origem == "E") {
        this.validaOsExterna = true
      }

      this.$root.confirmIdentity({
        onConfirmIdentity: (tecnicoId) => {

          const data = {
            idMecanico: tecnicoId,
            nr_os: this.$route.params.id
          }

          this.$store.dispatch('osItemExecucao/validateFromOsIniciadas', { data: data }).then(response => {
            if (typeof response.data.ordemServico.st_os != 'undefined') {

              if (response.data.ordemServico.st_os == 'E') {
                this.$swal.fire({
                  title: 'Oops!',
                  text: 'Esta OS já está encerrada!',
                  icon: 'error'
                })
                this.disabledPeca = false

                return false
              }
            }

            if (response.data.osEmAtendimento && this.os.st_origem != 'E') {
              this.$swal.fire({
                title: 'Oops!',
                text: 'Esta OS já está em atendimento!',
                icon: 'error'
              })

              return false
            }

            const filial = this.$store.getters['filial/filial']

            let validaOsEncerrada = false

            if (response.data.itemExecucao != null) {
              validaOsEncerrada = true

              if ((response.data.itemExecucao.item.os.st_os == 'E' && response.data.itemExecucao.item.os.st_origem == 'I') || filial.atendeOs == 'N') {
                validaOsEncerrada = false
              }

            } else {
              validaOsEncerrada = false
            }

            if ((response.data.itemExecucao || response.data.preventiva)
              && filial.fornecExt == null
              && validaOsEncerrada
              && filial.location != 'M') {
              this.$swal.fire({
                title: 'Oops!',
                html: `Você já está atendendo as OS N°: ${response.data.itemExecucao.item.os.nr_sequencial} <br>Encerre ou pause para iniciar outra!`,
                icon: 'warning'
              })
              this.disabledPeca = false

            } else {

              const fornecExt = this.$store.getters['filial/filial']

              const execucao = {
                nr_seq_os_item: this.item.nr_sequencial,
                nr_seq_clifor: tecnicoId,
                validaExt: null,
                nr_seq_tipo: this.os.nr_seq_tipo,
                osExterna: false,
                nr_os: this.$route.params.id
              }

              if (this.os.st_origem == "E") {
                execucao.nr_seq_clifor = fornecExt.tecnicoId,
                execucao.validaExt = fornecExt.tecnicoId,
                execucao.nr_os = this.$route.params.id,
                execucao.osExterna = true
              }

              this.$store.dispatch('osItemExecucao/create', { data: execucao }).then(response => {
                this.$store.dispatch('osItem/fetchItemFromApi', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
                const filial = this.$store.getters['filial/filial']
                const data = {
                  nr_seq_filial: filial.nr_sequencial
                }
                this.$store.dispatch('osItemExecucao/fetchIniciadasFromApi', { data: data })
                // this.$store.dispatch('os/refreshNavs')
                console.log(response)
                if(Array.isArray(response.data)){
                  window.location.pathname = `/os/${response.data[0].terminal_oficina_os_transicao}`
                }
              }).catch(() => {
                this.$swal.fire({
                  title: 'Oops!',
                  text: 'Falha ao iniciar execução. Tente novamente.',
                  icon: 'error'
                })
                return false
              })

            }

          })
        }
      }, this.validaOsExterna)
    },

    async validaTravaEmpilhadeira() {
      this.$store.dispatch('osItem/validaTravaEmpilhadeira', { data: this.os }).then(response => {

        if (response.data) {
          const requestOptions = {
            method: "GET",
            redirect: "follow"
          };

          const geoKey = response.data.filial.geo_key_smartlift
          const serie = response.data.veiculo.nr_chassi

          console.log(geoKey)
          console.log(serie)
 
          fetch(`https://www.geomov.com/apiserver/webapi/wsrest/remoterestrictionforklift?geokey=${geoKey}&serial=${serie}&type=3`, requestOptions)
            .then((response) => response.text())
            .then((result) => {
              let dataResult = JSON.parse(result)
              console.log(result)

              if (dataResult.machine.status != 2) {
                fetch(`https://www.geomov.com/apiserver/webapi/wsrest/remoterestrictionforklift?geokey=${geoKey}&serial=${serie}&type=2`, requestOptions)
                  .then((response) => response.text())
                  .then((result) => {
                    dataResult = JSON.parse(result)

                    setTimeout(() => {
                      console.log(result)
                      this.direcionaPagina()
                    }, 1000)
                  })
                  .catch((error) => console.error(error));
              }
            })
            .catch((error) => console.error(error));

        } else {
          this.direcionaPagina()
        }
      })
    },

    direcionaPagina() {
      if (this.os.nr_seq_tipo == 'V' || this.os.nr_seq_tipo == 'R' || this.os.tp_os == 'V' || this.os.tp_os == 'R') {
        window.location.reload()
      }

      const filial = this.$store.getters['filial/filial']

      if(filial.tipoPerfilTerminal == 'E'){
          window.location.href = '/osEmpilhadeira'
      } else {
          window.location.href = `/`
      }

      // if (this.os.st_origem == 'I' && this.os.nr_seq_tipo != 'V') {
      //   window.location.href = `/`
      //   return false
      // }

      if (this.os.nr_seq_tipo != 'V') {
        this.$store.dispatch('osItemExecucao/finalizaItem', { codOs: this.$route.params.id }).then(response => {
          const encerraOs = response.data.finalizaItem[0].terminal_oficina_encerra_os
          if (encerraOs == 'A') {
            // Ainda está Aberta
            this.show = false
            this.showModalItemsFim = false
          } else if (encerraOs == 'E') {
            // Já está fechada e direcionar para a home 
            const dsColaborador = this.$store.getters['filial/filial']
            // if (dsColaborador.fornecExt == 'S') {
            //   window.location.href = '/osExterna'
            // } else {
            //   window.location.href = `/`
            // }
            window.history.back();
          }
        })
      }
    },

    parar(objOs, executaExterna = false) {
      if (document.getElementById('formFiles').value != '') {

        const files = this.$store.state.os.filesUpload

        const formData = new FormData();

        for (let i = 0; i < files.length; i++) {
          formData.append('files[]', files[i]);
        }
        this.$store.dispatch(`os/uploadFiles`, { data: formData, nrSeqOs: this.$route.params.id }).then((response) => {
          // this.$swal.fire({
          //     title: 'Sucesso!',
          //     text: 'Anexos cadastrados com sucesso!',
          //     icon: 'success'
          // })

          this.submitFinalizacaoOS(objOs, executaExterna)
        })

      } else {
        this.submitFinalizacaoOS(objOs, executaExterna)
      }
    },

    async submitFinalizacaoOS(objOs, executaExterna = false) {
      const filial = JSON.parse(localStorage.filial);

      if (this.os.st_origem == "E") {
        this.validaOsExterna = true
      }
 
      this.showModalItemsFim = false
      this.showModalItems = false

      this.$root.confirmIdentity({
        onConfirmIdentity: (tecnicoId) => {
          if (executaExterna) {
            this.enviaOsExterna(executaExterna)
          }

          if(this.os.st_origem != 'E'){ 
            if (tecnicoId !== this.os.ultimoMecanicoAtendente.nr_seq_clifor_inicio) {
              this.$swal.fire({
                title: 'Ooops!',
                text: 'Outro mecânico inicou esta OS',
                icon: 'error'
              })
  
              return false
            }
          }

          // Executa Processo de Parar
          if (!objOs.nr_servico) {
            this.cod_item = this.item.nr_seq_item
          } else {
            this.cod_item = objOs.nr_servico
          }
          console.log(objOs)
          const execucao = {
            id: this.item.execucao_final.id,
            nr_seq_os_item_update: this.cod_item,
            nr_seq_os_item: this.item.nr_sequencial,
            nr_seq_os: this.$route.params.id,
            nr_seq_clifor: tecnicoId,
            nr_os: this.$route.params.id,
            validaExt: false,
            obsExterna: !objOs.obsExterna ? objOs.obsOS : objOs.obsExterna,
            km_atual: objOs.km_atual, 
            osExterna: false,
            motivo_soccoro_emrota: objOs.socorroEmRota
          }

          if (this.os.st_origem == "E") {
            this.show = false
            execucao.validaExt = true
            execucao.obsExterna = objOs.obsExterna
            execucao.nr_seq_clifor = filial.tecnicoId
            execucao.osExterna = true
            execucao.precoOS = Number(objOs.precoTotal)
          }

          if (this.os.segmento.habilita_pneus !== null) {
            if (this.os.segmento.habilita_pneus == 'S') {
              execucao.nr_pneu_atendimento = Number(objOs.pneuAtendimento.cd_pneu)
              execucao.nr_pneu_novo = Number(objOs.pneuNovo.cd_pneu)
            }
          }
          // console.log(objOs)
          // console.log(execucao)

          if (this.os.st_origem == "E" && !objOs.precoTotal) {
            this.$swal.fire({
              title: 'Oops!',
              text: 'Insira um preço!',
              icon: 'error'
            })

            return false
          }
          console.log(execucao)

          this.$store.dispatch('osItemExecucao/update', { data: execucao }).then(response => {

            this.validaTravaEmpilhadeira()
            
            this.$store.dispatch('osItem/notificacao', { nr_seq_os: this.$route.params.id })
            if (this.os.st_origem == "E") {
              this.$store.dispatch('osItem/fetchFromApi', { nrSeqOs: this.$route.params.id })
            }
            // window.location.href = '/' 

          }).catch(() => {
            this.$swal.fire({
              title: 'Oops!',
              text: 'Falha ao parar execução. Tente novamente.',
              icon: 'error'
            })

            return false
          })
        },
      }, this.validaOsExterna)
    },

    socorroEmRota() {
      try {
        if (this.os.nr_seq_socorro_emrota != null) {
          return true
        } else {
          return false
        }
      } catch (error) {
        return false
      }
    },

    resetPause(){
      this.pause = false
    },

    pausar() {
      this.$swal
        .fire({
          title: this.$t('Informe a Justificativa'),
          html: `<select class="custom-select custom-select-lg mb-3" id="selectJustificativa">
            <option selected>${this.$t('Justificativa')}</option>
            <option value="Ir ao banheiro">${this.$t('Ir ao banheiro')}</option>
            <option value="Atendimento">${this.$t('Atendimento')}</option>
            <option value="Refeicao">${this.$t('Refeição')}</option>
            <option value="Aguardando Peças">${this.$t('Aguardando Peças')}</option>
            <option value="Auxílio externo">${this.$t('Auxílio externo')}</option>
            <option value="Fim de expediente">${this.$t('Fim de expediente')}</option>
            </select>`,
          showCancelButton: true,
          cancelButtonColor: '#d33',
          cancelButtonText: this.$t('Cancelar'),
          confirmButtonText: this.$t('Confirmar Pausa')
        })
        .then(result => {
          if (result.value) {
            if (document.getElementById('selectJustificativa').value === 'Justificativa') {
              this.$swal.fire('Oops!', this.$t('Informe a Justificativa'), 'error')
            } else {
              const execucao = {
                nr_seq_os: this.$route.params.id,
                id: this.item.execucao_final.id,
                nr_seq_os_item: this.item.nr_sequencial,
                nr_seq_clifor: this.item.execucao_inicio.nr_seq_clifor_inicio,
                justificativa: document.getElementById('selectJustificativa').value
              }

              this.$store.dispatch('osItemExecucao/initPause', { data: execucao }).then(response => {
                this.$store.dispatch('osItem/fetchItemFromApi', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
                this.$store.dispatch('osItemExecucao/fetchIniciadasFromApi')
                // this.$store.dispatch('osItem/fetchItemFromApiPreventiva', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
                this.pause = false
                this.disabledPeca = false
              }).catch(() => {
                this.$swal.fire({
                  title: 'Oops!',
                  text: 'Falha ao pausar execução. Tente novamente.',
                  icon: 'error'
                })
  
                return false
              })
            }
          }
        })
        .catch(erro => {
          console.log('error', erro)
          this.$swal.fire('Oops!', 'Falha ao pausar', 'error')
        })
    },

    finalizarOsAntigaTransicao(tecnicoId) {


      const filial = JSON.parse(localStorage.filial);

      // Processo para continuar OS
      this.pause = !this.pause
      const execucaoInicio = {
        nr_seq_os_item: this.item.nr_sequencial,
        nr_seq_clifor: this.item.execucao_inicio.nr_seq_clifor_inicio,
        nr_os: this.$route.params.id,
      }

      this.$store.dispatch('osItemExecucao/create', { data: execucaoInicio }).then(response => {
        // Processo Finalizar OS Antiga

        this.cod_item = this.item.nr_seq_item
        console.log(response)
        const execucao = {
          id: response.data.execucao.id,
          nr_seq_os_item_update: this.cod_item,
          nr_seq_os_item: this.item.nr_sequencial,
          nr_seq_os: this.$route.params.id,
          nr_seq_clifor: this.item.execucao_inicio.nr_seq_clifor_inicio,
          nr_os: this.$route.params.id,
          validaExt: false,
          obsExterna: 'Os de Transição'
        }

        if (this.os.st_origem == "E") {
          this.show = false
          execucao.validaExt = true
          execucao.obsExterna = 'Os de Transição'
          execucao.nr_seq_clifor = filial.tecnicoId
        }

        this.$store.dispatch('osItemExecucao/update', { data: execucao }).then(response => { })
          .catch(() => {
            this.$swal.fire({
              title: 'Oops!',
              text: 'Falha ao parar execução. Tente novamente.',
              icon: 'error'
            })
          })
        
        const dataOs = {
          nr_os: this.$route.params.id,
          tecnico: filial.tecnicoId
        }

        if(this.item.execucao_final_os_transicao?.justificativa_pause == 'aguardando_orcamento'){
          this.$store.dispatch('os/finalizarOrcamento', { data: dataOs })
        }

      }).catch(() => {
        this.$swal.fire({
          title: 'Oops!',
          text: 'Falha ao iniciar execução. Tente novamente.',
          icon: 'error'
        })
      })


    },

    continuar() {
      if (this.isEncerrada) {
        this.$swal.fire({
          title: 'Atenção!',
          text: this.$t('Esta Ordem de Serviço já foi encerrada no GINFO. O atendimento não pode mais ser alterado.'),
          icon: 'warning'
        })
        return
      }
      this.disabledPeca = true
      this.$root.confirmIdentity({
        onConfirmIdentity: (tecnicoId) => {


          const data = {
            idMecanico: tecnicoId,
            nr_os: this.$route.params.id
          } 

          this.$store.dispatch('osItemExecucao/validateFromOsIniciadas', { data: data }).then(response => {
            if (typeof response.data.ordemServico.st_os != 'undefined') {
              if (response.data.ordemServico.st_os == 'E') {
                this.$swal.fire({
                  title: 'Oops!',
                  text: 'Esta OS já está encerrada!',
                  icon: 'error'
                })
                this.disabledPeca = false

                return false
              }
            }

            if (response.data.osEmAtendimento) {
              this.$swal.fire({
                title: 'Oops!',
                text: 'Esta OS já está em atendimento!',
                icon: 'error'
              })

              return false
            }


            const filial = this.$store.getters['filial/filial']

            let validaOsEncerrada = false
          
            // Verifica no backand se tem alguma execucao em aberto na item_execucao 
            if (response.data.itemExecucao != null) {
              validaOsEncerrada = true

              // Caso tiver execucao aberta, verifico se o st_os é igual a E, caso ela estiver encerrada deixa iniciar outra mesmo assim
              if ((response.data.itemExecucao.item.os.st_os == 'E' && response.data.itemExecucao.item.os.st_origem == 'I') || filial.atendeOs == 'N') {
                validaOsEncerrada = false
              }

            } else {
              validaOsEncerrada = false
            }

            if ((response.data.itemExecucao || response.data.preventiva)
              && filial.fornecExt == null
              && validaOsEncerrada
              && filial.location != 'M') {
              this.$swal.fire({
                title: 'Oops!',
                html: `Você já está atendendo as OS N°: ${response.data.itemExecucao.item.os.nr_sequencial} <br>Encerre ou pause para iniciar outra!`,
                icon: 'warning'
              })
              this.disabledPeca = false

            } else {

              if (tecnicoId != this.item.execucao_final.nr_seq_clifor_final) {

                this.finalizarOsAntigaTransicao(tecnicoId)
                this.gerarOsTransicao(tecnicoId)

              } else {

                this.pause = !this.pause

                const execucao = {
                  nr_seq_os_item: this.item.nr_sequencial,
                  nr_seq_clifor: this.item.execucao_inicio.nr_seq_clifor_inicio,
                  nr_os: this.$route.params.id
                }

                // console.log(this.item)
                // return false

                this.$store.dispatch('osItemExecucao/create', { data: execucao }).then(response => {

                  const dataOs = {
                    nr_os: this.$route.params.id,
                    tecnico: filial.tecnicoId
                  }
 
                  if(this.item.execucao_final?.justificativa_pause == 'aguardando_orcamento' || this.statusOrcamento == true){
                    this.$store.dispatch('os/finalizarOrcamento', { data: dataOs })
                  }

                  this.$store.dispatch('osItem/fetchItemFromApi', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
                  this.$store.dispatch('osItemExecucao/fetchIniciadasFromApi')
                  this.reloadOS()
                  this.disabledPeca = false
                }).catch(() => {
                  this.$swal.fire({
                    title: 'Oops!',
                    text: 'Falha ao iniciar execução. Tente novamente.',
                    icon: 'error'
                  })
                  return false
                })

              }
            }
          })
        }
      })
    },

    gerarOsTransicao(tecnicoId) {
      const execucao = {
        nrSeqOs: this.$route.params.id,
        nrSeqClifor: tecnicoId
      }

      this.$store.dispatch('osItemExecucao/gerarOsTransicao', { data: execucao }).then(response => {
        window.location.pathname = `/os/${response.data[0].terminal_oficina_os_transicao}`
      }).catch((error) => {
        throw new Error(error)
      })
    },

    reloadOS() {
      return this.$store.dispatch('os/getDetails', {
        nrSequencial: this.$route.params.id
      })
    },

    verificaBloqueioOC() {
      this.$store.dispatch('osItemExecucao/verificaOCAberta', { nr_seq_os: this.$route.params.id })
        .then(response => {
           if (response.data.existe_OC_aberta) {
              this.disabledContinuar = true
            } else {
              this.disabledContinuar = false
            }
        })
        .catch(error => {
          console.error('Erro ao verificar OC aberta:', error)
          throw new Error(error)
        })
    }
  }
}
</script>
<style>
  #video {
    transform: scaleX(1) !important;
  }


  @media screen and (max-width: 980px) {
    #video {
      width: 333px !important;
      height: 270px !important;
    }
  }
</style>